import './meetings.less';

angular.module("tromanWeb").factory('MeetingsShared', [function () {

    class MeetingsShared {
        constructor() {
            this.getAddIdCallback = null;
        }

        getAddId() {
            if (this.getAddIdCallback == null) {
                return null;
            }

            return this.getAddIdCallback();
        }
    }

    return MeetingsShared;
}]);
